/**
 * Welcome Step - Introduction + zero-trust privacy overview
 */

export default function Welcome({ onNext }: { onNext: () => void }) {
  return (
    <div className='bg-white shadow sm:rounded-lg'>
      <div className='px-4 py-5 sm:p-6'>
        <h2 className='text-2xl font-semibold text-gray-900'>
          Welcome to Injio Content Trust Dashboard 🎉
        </h2>

        <div className='mt-4 text-gray-600 space-y-4'>
          <p>
            We'll guide you through a quick setup to get your organization
            ready.
          </p>

          {/* Zero-trust privacy section */}
          <div className='rounded-md bg-blue-50 border border-blue-200 p-4'>
            <h3 className='text-sm font-semibold text-blue-900 mb-2'>
              Zero-Trust Processing
            </h3>
            <p className='text-sm text-blue-800 mb-3'>
              All SharePoint content analysis happens{' '}
              <strong>entirely in your browser</strong>.
            </p>
            <ul className='space-y-2 text-sm text-blue-800'>
              <li className='flex items-start'>
                <span className='text-[#2ba6bb] mr-2 font-bold'>✓</span>
                Your SharePoint data never leaves your computer
              </li>
              <li className='flex items-start'>
                <span className='text-[#2ba6bb] mr-2 font-bold'>✓</span>
                Only anonymized scores are sent to our servers
              </li>
              <li className='flex items-start'>
                <span className='text-[#2ba6bb] mr-2 font-bold'>✓</span>
                No page content, titles, or internal links are stored
              </li>
            </ul>
          </div>

          <p className='font-medium'>You'll complete these steps:</p>
          <ul className='list-disc list-inside space-y-2 ml-4'>
            <li>Confirm your organization details</li>
            <li>Connect to your SharePoint environment</li>
            <li>Select sites to scan</li>
            <li>Run your first health check</li>
          </ul>
          <p className='text-sm text-gray-500'>
            This takes about 10 minutes. You can pause and resume at any time.
          </p>
        </div>

        <div className='mt-6'>
          <button
            onClick={onNext}
            type='button'
            className='inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#2ba6bb] hover:bg-[#228a9d] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2ba6bb]'
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}
